import type { UserRole } from './types'

export const getUserRightsPerRole = (userRole: UserRole) => {
  switch (userRole) {
    case 'admin':
      return {
        canBulkEdit: true,
        canEditAll: true,
        canEditOwn: true,
        canViewExtraSearchDetails: true,
        canViewProvider: true,
      }
    case 'provider':
      return {
        canBulkEdit: true,
        canEditAll: false,
        canEditOwn: true,
        canViewExtraSearchDetails: true,
        canViewProvider: true,
      }
    case 'catEmployee':
    case 'user':
      return {
        canBulkEdit: false,
        canEditAll: false,
        canEditOwn: true,
        canViewExtraSearchDetails: false,
        canViewProvider: false,
      }
    default:
      return {
        canBulkEdit: false,
        canEditAll: false,
        canEditOwn: false,
        canViewExtraSearchDetails: false,
        canViewProvider: false,
      }
  }
}
